import React, { useEffect } from "react";
import "./SubfilterSide/Filter.css";
import { FilterSide } from "./SubfilterSide/RatingFilter";
import Pag from "./SubcardsSide/Pag";
import { useParams, useLocation, useHistory, Link } from "react-router-dom";
import { useState } from "react";
import { MdOutlineSwapVert } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import { link } from "../../config";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";

export default function SubcatigoryPage(props) {
  const {t} = useTranslation()
  const { id, page } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(5000000);
  const [selcetedcolors, setselectedcolors] = useState([]);
  const [selectedbrands, setselectedbrands] = useState([]);
  const [sale, setSale] = useState(null);
  const [beforeDays, setBeforeDays] = useState(null);
  const [rate, setRate] = useState(null);
  const [showfilter, setShowFilter] = useState(false);
  const [sliderSubCategory, setSliderSubCategory] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState({});

  const getBannersSubCategoriesFunc = async () => {
    try {
      const { data } = await axios.get(`${link}sliders/sub-category`);
      const result = data?.slider?.find(
        (item) => item?.subCategory?._id === id
      );

      setSliderSubCategory(result);
    } catch (error) {
      console.log(error);
    }
  };

  showfilter
    ? document.body.classList.add("stop-scrolling")
    : document.body.classList.remove("stop-scrolling");


    const getSubCategoryData = async () => {
      try {
        const { data } = await axios.get(`${link}subcategory/${id}`);
        setSubCategoryData(data);
     
      } catch (error) {
        console.log(error);
      }
    };

  useEffect(() => {
    getBannersSubCategoriesFunc();
    getSubCategoryData()

  }, []);
 
  

  return (
    <>
      <div
        className="w-100 d-flex justify-content-center mt-4 mb-5"
        style={{ direction: "rtl" }}
      >
        <div className="SabcatigoryPage ">
          <FilterSide
            id={id}
            page={page}
            maxPrice={maxPrice}
            minPrice={minPrice}
            setMinPrice={setMinPrice}
            setMaxPrice={setMaxPrice}
            selectedcolors={selcetedcolors}
            setselectedcolors={setselectedcolors}
            selectedbrands={selectedbrands}
            setselectedbrands={setselectedbrands}
            sale={sale}
            setSale={setSale}
            beforeDays={beforeDays}
            setBeforeDays={setBeforeDays}
            setRate={setRate}
            showfilter={showfilter}
            setShowFilter={setShowFilter}
            subCategoryData={subCategoryData}
          ></FilterSide>
          <div className="mx-4 flex-grow-1" style={{ width: "50vw" }}>
            <Swiper
              spaceBetween={30}
              centeredSlides={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              navigation={{
                prevEl: ".button-prev-slide",
                nextEl: ".button-next-slide",
              }}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper poster"
            >
              {sliderSubCategory?.images?.map((item, index) => (
                <SwiperSlide key={index}>
                  <Link to={item?.link || ""}>
                  <img
                    src={item?.secure_url}
                    alt={`Banner ${index}`}
                    style={{ width: "100%", height: "500px" }}
                  />
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
            <Pag
              id={id}
              page={page}
              maxPrice={maxPrice}
              minPrice={minPrice}
              selectedcolors={selcetedcolors}
              selectedbrands={selectedbrands}
              personal={props.personal}
              update_p={props.update_p}
              sale={sale}
              beforeDays={beforeDays}
              rate={rate}
              subCategoryData={subCategoryData}
            ></Pag>
          </div>
          <div className=" d-lg-none ">
            {!showfilter && (
              <div
                className="bg-black text-white filter-btn"
                onClick={() => setShowFilter(true)}
              >
                <span className="me-2">
                  <MdOutlineSwapVert />
                </span>
                <span>{t("filterwith")}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
